import { Flex, SimpleGrid } from '@chakra-ui/react'
import Controls from './components/Controls'
import DaysButtons from './components/DaysButtons'
import Title from './components/Title'

import { useMiniCalendar } from '../../contexts/MiniCalendarContext/Provider'

export default function Header() {
  const { withoutControls } = useMiniCalendar()
  return (
    <SimpleGrid columns={2} w="full" alignItems="center" mb={2}>
      <Flex gap={2}>
        {!withoutControls && (
          <>
            <Controls />
            <DaysButtons />
          </>
        )}
      </Flex>
      <Flex justifyContent="center">
        <Title />
      </Flex>
    </SimpleGrid>
  )
}
